import React, { useEffect, useState } from "react";
import { api, fileUrl } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Download } from "lucide-react";

export default function AdminWaitlistPage() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!loading && (!user || user.role !== "admin")) navigate("/");
  }, [loading, user, navigate]);

  useEffect(() => {
    if (user && user.role === "admin") {
      api.get("/admin/waitlist").then((r) => setRows(r.data));
    }
  }, [user]);

  const exportCsv = () => {
    const header = "email,name,kind,created_at\n";
    const csv = header + rows.map((r) =>
      [r.email, r.name || "", r.kind || "user", r.created_at].map((v) => `"${String(v).replace(/"/g, '""')}"`).join(",")
    ).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `waitlist-${new Date().toISOString().slice(0,10)}.csv`;
    a.click();
    URL.revokeObjectURL(url);
  };

  if (loading || !user || user.role !== "admin") return null;

  return (
    <div className="bg-[#F8FAFC] min-h-screen">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-12">
        <div className="flex items-end justify-between mb-8">
          <div>
            <p className="eyebrow mb-2">Admin · Lista de espera</p>
            <h1 className="font-serif text-4xl font-semibold text-[#1A1A1A]">Interesados en el lanzamiento</h1>
            <p className="text-[#475569] mt-2 text-sm">Total: {rows.length}</p>
          </div>
          <Button data-testid="export-waitlist" onClick={exportCsv} disabled={!rows.length} className="rounded-none h-11 bg-[#1A1A1A] hover:bg-[#2A2A2A] text-[#F8FAFC]">
            <Download className="w-4 h-4 mr-2" /> Exportar CSV
          </Button>
        </div>
        {rows.length === 0 ? (
          <p className="text-[#475569]">Aún no hay inscripciones.</p>
        ) : (
          <div className="bg-white border border-[#E2E8F0]">
            <table className="w-full text-sm">
              <thead className="bg-[#EEF2F7] border-b border-[#E2E8F0]">
                <tr>
                  <th className="text-left px-4 py-3 font-mono uppercase text-[10px] tracking-widest text-[#475569]">Email</th>
                  <th className="text-left px-4 py-3 font-mono uppercase text-[10px] tracking-widest text-[#475569]">Nombre</th>
                  <th className="text-left px-4 py-3 font-mono uppercase text-[10px] tracking-widest text-[#475569]">Tipo</th>
                  <th className="text-left px-4 py-3 font-mono uppercase text-[10px] tracking-widest text-[#475569]">Fecha</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r) => (
                  <tr key={r.id} className="border-b border-[#EEF2F7]">
                    <td className="px-4 py-3 font-medium text-[#1A1A1A]">{r.email}</td>
                    <td className="px-4 py-3 text-[#475569]">{r.name || "—"}</td>
                    <td className="px-4 py-3">
                      <span className={`inline-block px-2 py-0.5 text-[10px] font-mono uppercase tracking-widest border ${r.kind === "empresa" ? "cat-negocios" : "cat-viajes"}`}>
                        {r.kind || "user"}
                      </span>
                    </td>
                    <td className="px-4 py-3 text-[#64748B] text-xs">{new Date(r.created_at).toLocaleString("es-ES")}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
